import React from "react";
import theme from "../../../styles/theme";

const CardHome = ({ title, children, titleColor, img, bgColor = theme.colors.background.surface, imgWidth, imgHeight, description, width = "250px", height = "320px", onClick }) => {
  return (
    <div
      onClick={onClick}
      style={{
        border: `1px solid ${theme.colors.borders.contraste}`,
        borderRadius: theme.borders.radius.xl,
        padding: theme.spacing.md,
        margin: theme.spacing.md,
        backgroundColor: bgColor,
        boxShadow: theme.shadows.sm,
        transition: "all 0.2s",
        cursor: onClick ? "pointer" : "default",
        width,  // 👈 défini par la prop
        height, // 👈 défini par la prop
        imgWidth: "80px",
        imgHeight: "80px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        overflow: "hidden",
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.boxShadow = theme.shadows.md;
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.boxShadow = theme.shadows.sm;
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {img && (
        <img
          src={img}
          alt={title}
          style={{
            width: imgWidth,
            height: imgHeight,
            objectFit: "contain",
            marginBottom: theme.spacing.sm,
          }}
        />
      )}
      {title && (
        <h3
          style={{
            fontSize: theme.fontSizes.lg,
            fontWeight: theme.fontWeights.medium,
            color: titleColor || theme.colors.text.default, // <-- utiliser la prop
            marginBottom: theme.spacing.sm,
          }}
        >
          {title}
        </h3>
      )}
      {children && <div>{children}</div>}
      
      {description && (
        <h4
          style={{
            fontSize: theme.fontSizes.md,
            //color: theme.colors.text.secondary,
            marginTop: 0,
            marginBottom: theme.spacing.sm,
          }}
        >
          {description}
        </h4>
      )}

    </div>
  );
};

export default CardHome;
